/** Sub-project payload shape from getSubProjectDetails (MCC / Construction Loan). */
export function isSubProjectAwaitingCrossCheckStart(
  data: Record<string, unknown> | null | undefined
): boolean {
  if (!data) return false;

  const rawResults = Array.isArray(data.cross_checks_results) ? data.cross_checks_results : [];
  const activeResults = rawResults.filter((clause) => !(clause as { stale?: boolean }).stale);
  if (activeResults.length > 0) return false;

  const cra = data.client_requests_assignments_results as { requests?: unknown[] } | null | undefined;
  const identified = Array.isArray(cra?.requests) ? cra.requests : [];
  if (identified.length > 0) return false;

  const progress = data.cross_check_progress;
  const progressObj =
    progress && typeof progress === 'object' && !Array.isArray(progress)
      ? (progress as Record<string, unknown>)
      : null;

  if (!progressObj || Object.keys(progressObj).length === 0) return true;

  const status = String(progressObj.status ?? '').toLowerCase();
  if (status === 'completed' || status === 'complete') return false;
  if (status === 'error' || status === 'failed') return false;
  if (progressObj.is_active === true) return false;
  if (status === 'running' || status === 'in_progress') return false;

  const workflowStep = progressObj.workflow_step;
  if (typeof workflowStep === 'number' && workflowStep >= 1) return false;

  return true;
}
